module.exports = "./img/68b79bf0423e6eae5d8986763d636909.png";